export default function Logo({ className = "h-8 w-auto", variant = "full" }) {
  if (variant === "icon") {
    return (
      <svg
        className={className}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="OrbixGloble Icon"
      >
        <circle
          cx="24"
          cy="24"
          r="20"
          stroke="#0B2340"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M24 4C24 4 14 12 14 24C14 36 24 44 24 44"
          stroke="#0B2340"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M24 4C24 4 34 12 34 24C34 36 24 44 24 44"
          stroke="#0B2340"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M4 24H44"
          stroke="#D4AF37"
          strokeWidth="2"
        />
        <path
          d="M10 14H38"
          stroke="#D4AF37"
          strokeWidth="1.5"
          opacity="0.6"
        />
        <path
          d="M10 34H38"
          stroke="#D4AF37"
          strokeWidth="1.5"
          opacity="0.6"
        />
        <path
          d="M20 18L22 14L24 16L26 12L28 15L30 11"
          stroke="#00B37E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  return (
    <svg
      className={className}
      viewBox="0 0 200 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="OrbixGloble Logo"
    >
      {/* Icon */}
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="#0B2340"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M24 4C24 4 14 12 14 24C14 36 24 44 24 44"
        stroke="#0B2340"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M24 4C24 4 34 12 34 24C34 36 24 44 24 44"
        stroke="#0B2340"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M4 24H44"
        stroke="#D4AF37"
        strokeWidth="2"
      />
      <path
        d="M10 14H38"
        stroke="#D4AF37"
        strokeWidth="1.5"
        opacity="0.6"
      />
      <path
        d="M10 34H38"
        stroke="#D4AF37"
        strokeWidth="1.5"
        opacity="0.6"
      />
      <path
        d="M20 18L22 14L24 16L26 12L28 15L30 11"
        stroke="#00B37E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Text */}
      <text
        x="58"
        y="32"
        fontFamily="Poppins, sans-serif"
        fontSize="22"
        fontWeight="700"
        fill="#0B2340"
      >
        OrbixGloble
      </text>
    </svg>
  )
}
